<div class="overlay" *ngIf="isOpen" (click)="close.emit()"></div>

<div class="sidebar" [class.open]="isOpen">
  <ng-content></ng-content>
</div>
